import { CommonModule, CurrencyPipe } from "@angular/common";
import { Component, computed, input } from "@angular/core";
import { TranslocoPipe } from "@jsverse/transloco";
import { isDefined } from "@recursyve/nice-ts-utils";
import { SvgIconComponent } from "angular-svg-icon";
import { DirectusTranslationPipe } from "../../../../common/pipes/directus-translation.pipe";
import { PathFromItemPipe } from "../../../../common/pipes/path-from-item.pipe";
import {
    sanitizeDirectusObject,
    sanitizeDirectusRelationArray
} from "../../../../common/utils/sanitize-directus-object";
import { ItemsPackageBlock } from "../../../api/packbo/models/items-package-block";
import { PackageBadgeComponent } from "../../../components/package-badge/package-badge.component";

@Component({
    selector: "packbo-package-block",
    templateUrl: "./package-block.template.html",
    imports: [
        DirectusTranslationPipe,
        PackageBadgeComponent,
        TranslocoPipe,
        CurrencyPipe,
        SvgIconComponent,
        CommonModule,
        PathFromItemPipe
    ]
})
export class PackageBlockComponent {
    public readonly packageBlock = input.required<ItemsPackageBlock>();
    public readonly isFirst = input(false);

    protected readonly package = computed(() => sanitizeDirectusObject(this.packageBlock().package));
    protected readonly packagesFeaturesRefs = computed(() => this.packageBlock().packages_features_refs);
    protected readonly packageFeatures = computed(() =>
        sanitizeDirectusRelationArray(this.packagesFeaturesRefs(), "package_features_id")
            .map((feature) => sanitizeDirectusObject(feature))
            .filter(isDefined)
    );
    protected readonly link = computed(() => sanitizeDirectusObject(this.packageBlock().link));
}
